import { useState, useLayoutEffect } from 'react';

export interface DimensionObject {
  width: number;
  height: number;
  top: number;
  left: number;
  x: number;
  y: number;
  right: number;
  bottom: number;
}

function getDimensionObject(node: HTMLElement): DimensionObject {
  const rect = node.getBoundingClientRect();
  return {
    width: rect.width,
    height: rect.height,
    top: rect.y | rect.top,
    left: rect.x | rect.left,
    x: rect.x | rect.left,
    y: rect.y | rect.top,
    right: rect.right,
    bottom: rect.bottom,
  };
}

function useElementDimensions({ liveMeasure = true, elementRef }) {
  const [dimensions, setDimensions] = useState({
    width: null,
    height: null,
    top: null,
    left: null,
    x: null,
    y: null,
    right: null,
    bottom: null,
  });

  const node = elementRef?.current;

  useLayoutEffect(() => {
    if (node) {
      const measure = () => window.requestAnimationFrame(() => setDimensions(getDimensionObject(node)));
      measure();

      if (liveMeasure) {
        window.addEventListener('resize', measure);
        window.addEventListener('scroll', measure);

        return () => {
          window.removeEventListener('resize', measure);
          window.removeEventListener('scroll', measure);
        };
      }
    }
  }, [node]);

  return dimensions;
}

export default useElementDimensions;
